import React from 'react';
import { Check } from 'lucide-react';

/**
 * Reusable "profile X% complete" card with progress bar + checklist.
 *
 * Props:
 *   completeness: { pct, filled, total, items: [{ key, label, filled }] }
 *   title (default "Perfil X% completo")
 *   testid (default 'completeness-card')
 */
export default function CompletenessCard({ completeness, testid = 'completeness-card' }) {
  if (!completeness) return null;
  const { pct = 0, items = [] } = completeness;
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-5" data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <p className="font-serif font-bold text-habita-dark">Perfil {pct}% completo</p>
        {pct === 100 && (
          <span className="px-2.5 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold uppercase">✓ Perfil optimizado</span>
        )}
      </div>
      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-habita to-emerald-500 transition-all"
          style={{ width: `${pct}%` }}
          data-testid={`${testid}-bar`}
        />
      </div>
      {items.length > 0 && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-1.5 mt-4 text-xs">
          {items.map(it => (
            <div key={it.key} className="flex items-center gap-1.5" data-testid={`${testid}-item-${it.key}`}>
              {it.filled
                ? <span className="w-4 h-4 rounded-full bg-habita-mint text-habita flex items-center justify-center"><Check className="w-2.5 h-2.5" strokeWidth={3} /></span>
                : <span className="w-4 h-4 rounded-full border border-gray-300" />}
              <span className={it.filled ? 'text-gray-700' : 'text-gray-400'}>{it.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
